import { useMemo } from 'react';
import { IFamilyMemberDto } from '../../../../utils/constants/interfaces';

interface UseSecondaryAdultMemberProps {
  secondaryMember: IFamilyMemberDto | null;
  fieldErrors: string[];
}

export const useSecondaryAdultMember = ({
  secondaryMember,
  fieldErrors
}: UseSecondaryAdultMemberProps) => {
  const hasSecondaryMember = useMemo(() => {
    return Boolean(secondaryMember?.id);
  }, [secondaryMember?.id]);

  const hasValidContactInfo = useMemo(() => {
    if (!secondaryMember) return false;
    return Boolean(
      secondaryMember.emailAddress || secondaryMember.homePhone || secondaryMember.cellPhone
    );
  }, [secondaryMember?.emailAddress, secondaryMember?.homePhone, secondaryMember?.cellPhone]);

  const hasValidAddress = useMemo(() => {
    if (!secondaryMember) return false;
    return Boolean(
      secondaryMember.address &&
        secondaryMember.city &&
        secondaryMember.state &&
        secondaryMember.zipCode
    );
  }, [
    secondaryMember?.address,
    secondaryMember?.city,
    secondaryMember?.state,
    secondaryMember?.zipCode
  ]);

  const hasRequiredFields = useMemo(() => {
    if (!secondaryMember) return false;
    return Boolean(
      secondaryMember.firstName &&
        secondaryMember.lastName &&
        secondaryMember.memberStatusId &&
        secondaryMember.firstJoinedDateUtc
    );
  }, [
    secondaryMember?.firstName,
    secondaryMember?.lastName,
    secondaryMember?.memberStatusId,
    secondaryMember?.firstJoinedDateUtc
  ]);

  const hasFieldErrors = useMemo(() => {
    return fieldErrors.some((error) => error.startsWith('family:'));
  }, [fieldErrors]);

  return {
    hasSecondaryMember,
    hasValidContactInfo,
    hasValidAddress,
    hasRequiredFields,
    hasFieldErrors
  };
};
